/// <reference path="../../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";
import * as Rest from "../../Generated/RestClient";
import {BotCodeEditor, BotCodeEditorProps, BotCodeEditorState, mapFilesToTreeNodes, ExpiredSubscrition} from "../Views/index";
import {ControllerBase} from "./ControllerBase";
import { DevPortalAppBase } from "../../DevPortalAppBase";
import {TreeNode} from "react-treebeard";
import {KuduClient} from "../../Services/KuduApi";
import {ArmClient} from "../../Services/ArmApi";
import {Poller} from "../../Models/PollingModel";
import {parseUrl} from "../../../../Intercom.ReactUI/Utils/Url";
import {resolve} from "../../../../Intercom.ReactUI/Utils/Path";
import logger from "../../../../Intercom.ReactUI/Utils/logger";
import {BladeType} from "../Services/azurePortalLinks";

const relativePathRegex = /^https:\/\/[^\/]+\/api\/vfs\/site\/wwwroot\/(.*)$/g;

export class BotCodeEditorController extends ControllerBase {
    public subscriptionId: string;
    private state: BotCodeEditorState;
    private botId: string;
    private component: BotCodeEditor;
    private KuduClient: KuduClient;
    private poller: Poller<string>;
    private functionName: string;
    private botCodeFetched: string;
    private _armClient: ArmClient;


    constructor(app: DevPortalAppBase, container: ControllerBase) {
        super(app);
        this.containerController = container;
    }

    public setComponent(editor: BotCodeEditor) {
        this.component = editor;
        if (this.component && this.botId && this.botId != this.botCodeFetched) {
            this.fetchCode();
        } else if (this.component && this.state) {
            this.component.setState(this.state);
        }
    }

    public render(params: SimpleMvc.QueryParams): void {
        super.render(params);

        this.botId = params["id"];

        this.renderPage();
    }

    public unload() {
        super.unload();
        if (this.poller) {
            this.poller.stop();
            this.poller = null;
        }
    } 

    private relativeCodePath(url: string) : string {
        var matches = relativePathRegex.exec(url);
        if (matches) {
            var result = matches[1];
            relativePathRegex.lastIndex = 0;
            return result;
        } else {
            return "";
        }
    }

    private get armClient(): ArmClient {
        if (!this._armClient) {
            this._armClient = new ArmClient(this.azureAccessToken);
        }
        return this._armClient;
    }

    private checkSubscription(): JQueryPromise<boolean> {
        let deferred = $.Deferred();
        this.armClient.getSubscription(this.subscriptionId).then(sub => {
            deferred.resolve(sub && sub.state == "Enabled");
        }).fail(xhr => {
            if (xhr && xhr.status == 404) {
                deferred.resolve(false);
            } else {
                deferred.reject(xhr);
            }
        })
        return deferred;
    }

    private toggleTreeNode(node: TreeNode, toggle: boolean): JQueryPromise<TreeNode> {
        let deferred = $.Deferred();

        // null check
        if (!node) {
            deferred.reject();
            return deferred;
        }

        node.toggled = toggle;
        const isFolder = node.id.slice(-1) === '/';

        if (this.state.activeNode) {
            const prevCursorPos = this.component.getCursorPosition();
            this.state.activeNode['cursorPos'] = prevCursorPos;
        }

        if (isFolder) {
            if (node.toggled) {
                node.loading = true;
                this.KuduClient.get(node.id === '/' ? `${this.KuduClient.scmUri.format()}/api/vfs/site/wwwroot/` : node.id)
                    .done((files : Rest.VfsNodeInfo[]) => {
                        node.loading = false;
                        node.children = mapFilesToTreeNodes(files);
                        this.component.setState(this.state);
                        deferred.resolve(node);
                    });
            } else {
                node.children = [];
                deferred.resolve(node);
            }
        } else {
            let okToSwitch = $.Deferred();

            if (this.state.activeFile && this.state.activeCodeDirty) {
                let curNode = this.state.activeFile;
                this.updateFile(curNode.id, this.state.activeCode).then(() => {
                    this.state.activeCodeDirty = false;
                    if (curNode && curNode.newFile) {
                        // we just saved file, this file no longer new
                        curNode.newFile = undefined;
                    }

                    okToSwitch.resolve(true);
                }).fail(() => {
                    okToSwitch.resolve(false);
                });
            } else {
                okToSwitch.resolve(true);
            }

            okToSwitch.then((f: boolean) => {
                if (f) {
                    this.state.activeFile = node;
                    if (!node.newFile) {
                        node.loading = true;
                        this.KuduClient.get(node.id)
                            .done((txt: string) => {
                                node.loading = false;
                                this.state.activeCode = txt;
                                this.component.setState(this.state, () => {
                                    this.component.resetUndoStack();
                                });
                            });
                    } else {
                        this.state.activeCode = "";
                        this.component.setState(this.state);
                    }
                    deferred.resolve(node);
                } else {
                    deferred.reject();
                }
            });
        }

        if (this.state.activeNode) {
            this.state.activeNode.active = false;
        }
        node.active = true;
        this.state.activeNode = node;
        this.component.setState(this.state);

        return deferred;
    }

    private updateFile(url: string, content: string): JQueryPromise<boolean> {
        let deferred = $.Deferred();
        this.KuduClient.put(url, content)
            .then(() => {
                deferred.resolve(true);
            })
            .fail(xhr => {
                deferred.reject(false);
                this.handleHttpResponseError(xhr);
            });
        return deferred;
    }

    private saveFile(url: string, content: string) {
        this.updateFile(url, content).done(() => {
            this.state.activeCode = content;
            this.state.activeCodeDirty = false;
            const node = this.findNodeById(url);
            if (node && node.newFile) {
                // we just saved file, this file no longer new
                node.newFile = undefined;
            }
            this.component.setState(this.state);
        }).fail(xhr => this.handleHttpResponseError(xhr));
    }

    private appendLogStream(t: string) {
        // append the log stream
        if (t) {
            const oldLength = this.state.logStream.length;
            const newLength = oldLength + t.length;
            const MaxLength = 500000;
            let startIndex = 0;
            if (newLength > MaxLength) {
                startIndex = newLength - MaxLength;
            }
            this.state.logStream = this.state.logStream.substr(startIndex) + t;
            if (this.component) {
                this.component.setState(this.state);
            }
        }
    }

    private onLogStreamStopped() {
        logger.debug('log stream stopped, reconnect');
        this.poller = this.KuduClient.logStream(this.functionName, _.bind(this.appendLogStream, this));
        this.poller.start();
        this.poller.onStop(() => this.onLogStreamStopped());
    }

    private fetchCode() {
        if (!this.botId) {
            return;
        }

        var newState: BotCodeEditorState = {
            root: {
                id: "/",
                name: this.botId,
                toggled: true,
                loading: false
            },
            activeNode: null,
            activeFile: null,
            activeCode: "",
            activeCodeDirty: false,
            logStream: "",
        };

        var checkAllInfo = () => {
            if (newState.root.children) {
                this.state = newState;
                if (this.component) {
                    this.component.setState(this.state);
                }
            }
        }

        this.botCodeFetched = this.botId;

        let fetchRoot = Rest.CodeClient.getScmAuthz(this.botId)
            .then(authz => {
                this.KuduClient = KuduClient.createFromScmAuthorization(authz);
                return this.KuduClient.get(`${this.KuduClient.scmUri.format()}/api/vfs/site/wwwroot/`)
            })
            .then((items: Rest.VfsNodeInfo[]) => {
                if (this.component) {
                    this.component.setState({lastFetchTime: new Date()} as any);
                }
                // find the function name
                let deferred = $.Deferred();
                let functionName = _.find(items, (item: Rest.VfsNodeInfo) => item.mime === 'inode/directory').name;
                if (this.component && this.component.props && this.component.props.botEndpoint) {
                    let uri = parseUrl(this.component.props.botEndpoint);
                    functionName = _.last(uri.path.split('/'));
                }
                this.functionName = functionName;
                this.poller = this.KuduClient.logStream(functionName, _.bind(this.appendLogStream, this));
                this.poller.onStop(()=> this.onLogStreamStopped());
                this.poller.start();

                newState.root.children = mapFilesToTreeNodes(items);

                checkAllInfo();
                // navigate to the function folder
                let functionRoot = _.find(newState.root.children, node => node.name == functionName && node.children);
                if (functionRoot) {
                    deferred.resolve(functionRoot);
                } else {
                    // otherwise just resolve to the root
                    deferred.resolve(newState.root);
                }
                return deferred;
            });

        $.when(fetchRoot)
            .then((node: TreeNode) => {
                // expand the function folder tree node
                let deferred = this.toggleTreeNode(node, true);
                checkAllInfo();
                return deferred;
            })
            .then((node: TreeNode) => {
                // now navigate to either run.csx or index.js
                let file = _.find(node.children, child => child.name == 'run.csx' || child.name == 'index.js');
                // fallback to first file
                file = file || _.find(node.children, child => !child.children);
                checkAllInfo();
                return this.toggleTreeNode(file, true);
            })
            .fail(xhr => {
                this.botCodeFetched = null;
                this.checkSubscription().then(valid => {
                 if (valid) {
                    this.handleHttpResponseError(xhr);
                 } else {
                     this.statusBar = React.createElement(ExpiredSubscrition, {});
                 }
                }).fail(() => {
                    this.handleHttpResponseError(xhr);
                })
            });
    }

    private findNodeById(id: string) {
        let level = this.state.root.children;
        for (; ;) {
            let match = _.find(level, node => id.indexOf(node.id) === 0);
            if (!match || match.id === id) {
                return match;
            }
            level = match.children;
            if (!level) {
                return null;
            }
        }
    }

    private findParent(root: TreeNode, cur: TreeNode): TreeNode {
        // compute the parent Id
        let curUrl = parseUrl(cur.id);
        curUrl.path = resolve(curUrl.path, '..');
        let parentId = `${curUrl.format()}/`;
        return this.findNodeById(parentId);
    }

    private addNewFile() {
        // first find the current folder
        let cur = this.state.activeNode;
        if (cur) {
            if (!cur.children) {
                // cur node is a file
                // find its parent
                cur = this.findParent(this.state.root, cur);
            }
        }

        if (cur) {
            // make sure the folder is open
            let newFile: TreeNode = {
                name: '_new',
                id: `${cur.id}_new`,
                newFile: true,
            }
            cur.toggled = true;
            cur.children.splice(0, 0, newFile);
            this.state.newFileNodeId = newFile.id;
            let setNewFilew = () => {
                this.state.activeFile = newFile;
                this.state.activeCode = '';
                this.component.setState(this.state);
            };

            if (this.state.activeFile && this.state.activeCodeDirty) {
                this.updateFile(this.state.activeFile.id, this.state.activeCode)
                    .then((ok) => {
                        if (ok) {
                            setNewFilew();
                        }
                    });
            }
            else {
                setNewFilew();
            }
        }
    }

    private onRenameFile(newName: string) {
        // TODO: validate file name
        logger.debug('newName', newName);
        if (newName.indexOf('/') >= 0 || newName.indexOf('..') >= 0) {
            return;
        }
        let treeNode = this.findNodeById(this.state.newFileNodeId);
        if (treeNode) {
            const parentId = treeNode.id.substr(0, this.state.newFileNodeId.lastIndexOf('/') + 1);
            treeNode.name = newName.trim();
            if (treeNode.name.length) {
                treeNode.id = parentId + treeNode.name;
                this.state.newFileNodeId = undefined;
            } else {
                treeNode.id = parentId + '_new';
            }
        }
        this.component.setState(this.state);
    }

    private onChangeCode(txt: string, dirty: boolean) {
        this.state.activeCode = txt;
        this.state.activeCodeDirty = dirty;
        this.component.setState(this.state);
    }

    private clearLogStream() {
        this.state.logStream = '';
        this.component.setState(this.state);
    }

    public getBotCodeEditorProps(props: Partial<BotCodeEditorProps>): BotCodeEditorProps {
        return _.extend({
            botId: this.botId,
            onToggle: _.bind(this.toggleTreeNode, this),
            onSave: _.bind(this.saveFile, this),
            onSetBotId: _.bind(this.setBotId, this),
            onAddFile: _.bind(this.addNewFile, this),
            onRenameFile: _.bind(this.onRenameFile, this),
            onChangeCode: _.bind(this.onChangeCode, this),
            clearLogStream: _.bind(this.clearLogStream, this)
        }, props || {});
    }

    private renderPage(container?: Element, props?: BotCodeEditorProps) {
        container = container || this.pageContent;
        let element = React.createElement(BotCodeEditor,
            this.getBotCodeEditorProps(props));
        this.component = ReactDOM.render<BotCodeEditorProps, BotCodeEditor>(element, container) as BotCodeEditor;
        if (this.botId) {
            this.fetchCode();
        }
    }

    public setBotId(botId: string, subscriptionId: string) {
        this.botId = botId;
        if (subscriptionId) {
            this.subscriptionId = subscriptionId;
        }
        if (this.component && this.botId != this.botCodeFetched) {
            this.fetchCode();
        }
    }


    public get codeEditor() : BotCodeEditor {
        return this.component;
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Controllers/BotCodeEditorController.ts